// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';


const VoucherInfo = (props) => {
  const {
    classes,
    bookshopCustomer,
  } = props;

  return Object.keys(bookshopCustomer).length !== 0 && (
    <div className={classes.container}>

      <div className={classes.priceContainer}>
        <p className={classes.descText}>Gift voucher amount:</p>
        <div className={classes.circle}>
          <p className={classes.priceText}>
            {`£${parseFloat(bookshopCustomer.Voucher.IssueValue).toFixed(2)}`}
          </p>
        </div>
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.row}>
          <p className={classes.descText}>Full Name:</p>
          <p className={classes.text}>{`${bookshopCustomer.FullName}`}</p>
        </div>
        <div className={classes.row}>
          <p className={classes.descText}>Email:</p>
          <p className={classes.text}>{`${bookshopCustomer.Email}`}</p>
        </div>
        <div className={classes.row}>
          <p className={classes.descText}>Mobile:</p>
          <p className={classes.text}>{`${bookshopCustomer.Mobile}`}</p>
        </div>
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.row}>
          <p className={classes.descText}>Order no:</p>
          <p className={classes.text}>{`${bookshopCustomer.Voucher.OrderId}`}</p>
        </div>
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.row}>
          <p className={classes.descText}>Code:</p>
          <p className={classes.text}>{`${bookshopCustomer.Voucher.Code}`}</p>
        </div>
        <div className={classes.row}>
          <p className={classes.descText}>Expires:</p>
          <p className={classes.text}>
            {bookshopCustomer.Voucher.ExpiryDate
              ? moment(bookshopCustomer.Voucher.ExpiryDate).format('DD/MM/YYYY')
              : '-'}
          </p>
        </div>
      </div>
      {/* Rendered by the service rather than a JS barcode library:
          GetVoucherBarcode is the one voucher endpoint that needs no auth
          token - it draws whatever code it is handed and touches no data -
          which is what lets an <img> fetch it directly, here and from the
          voucher email. Saves adding a barcode dependency to this app. */}
      <div className={classes.barcodeContainer}>
        <img
          className={classes.barcodeImage}
          alt={`Barcode for voucher ${bookshopCustomer.Voucher.Code}`}
          // Relative, not BASE_URL: the site is served over https and
          // BASE_URL is http on staging, so the browser blocked the image as
          // mixed content. Every other call this app makes is same-origin and
          // relative, and the barcode is served by the same service.
          src={`/Sellitback.svc/GetVoucherBarcode?Code=${encodeURIComponent(bookshopCustomer.Voucher.Code)}`}
        />
      </div>
    </div>
  );

};

VoucherInfo.propTypes = {
  classes: PropTypes.object,
  bookshopCustomer: PropTypes.object,

};
VoucherInfo.defaultProps = {
  classes: {},
  bookshopCustomer: {},
};

export default withStyles(styles)(VoucherInfo);
